import { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { User } from '../types/user';

type GetUserResponse = {
    user: User;
};

async function getUser(id?: string): Promise<GetUserResponse> {
    const { data } = await api.get(`/users/${id}`);
    return data;
}

export function useUser(id?: string): UseQueryResult<GetUserResponse, AxiosError> {
    return useQuery(['user', id], () => getUser(id), { enabled: Boolean(id), keepPreviousData: true });
}
